import PackingOrderReviewTop from "./packing-order-review-top";
import PackingOrderReviewItems from "./packing-order-review-items";
import { useReactToPrint } from "react-to-print";
import { useEffect, useRef } from "react";
import { Toast } from 'primereact/toast';

const PackingNewOrderReview = (props: any) => {
  const componentRef = useRef(null);
  const toast = useRef<Toast>(null);
  
  useEffect(() => {
    if(props.PrintEnabled) {
      handleOrderPrint();
    }      
  }, [props.PrintEnabled]);

  const handleOrderPrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'Order Detail',
    onAfterPrint: () => props.TriggerPrint(false)
  });

  if (!props.OrderData || !props.OrderData.orderID) {
    return (
      <div className="p-4">
        <Toast ref={toast} />
        <div className="text-center p-4 border-1 surface-border">
          <p>No details found for this order</p>
        </div>
      </div>
    );
  }
  
  return (
    <>
      <div ref={componentRef} className="flex flex-column border-1 surface-border box-shadow-none m-0" style={{ width: "60%" }}>
        <PackingOrderReviewTop orderData={props.OrderData} />
        <PackingOrderReviewItems orderedItems={props.OrderData} />
      </div>
    </>
  );
};

export default PackingNewOrderReview;